import { render, staticRenderFns } from "./ModattaNewOfferStepSuccess.vue?vue&type=template&id=7cb5531f"
import script from "./ModattaNewOfferStepSuccess.vue?vue&type=script&lang=js"
export * from "./ModattaNewOfferStepSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports